import { render, staticRenderFns } from "./AnniversaryBanner.vue?vue&type=template&id=3237365b&"
import script from "./AnniversaryBanner.vue?vue&type=script&lang=js&"
export * from "./AnniversaryBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports